import { render, staticRenderFns } from "./buscador_productos.vue?vue&type=template&id=8acdec56&"
import script from "./buscador_productos.vue?vue&type=script&lang=js&"
export * from "./buscador_productos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports